/*
  GW recently viewed: remembers the last 9 product IDs (current piece + 8) and shows 8.
  The theme default keeps 5 and shows 4 (assets/global.js, left untouched).
  Loaded from sections/recently-viewed-products.liquid. Styles: assets/gw-card.css.
*/
(function () {
  var KEY = 'gw:recently-viewed';
  var THEME_KEY = 'beyours:recently-viewed';
  var KEEP = 9;
  var SHOW = 8;

  function read(key) {
    try {
      var value = JSON.parse(window.localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, KEEP)));
    } catch (e) {}
  }

  // Build our list, carrying over anything the theme already remembered.
  var list = read(KEY);
  read(THEME_KEY).forEach(function (id) {
    if (list.indexOf(id) === -1) list.push(id);
  });

  // On a product page, put the current piece first.
  var host = document.querySelector('recently-viewed-products[data-product-id]');
  var current = host ? parseInt(host.getAttribute('data-product-id'), 10) : null;
  if (current) {
    list = list.filter(function (id) { return id !== current; });
    list.unshift(current);
  }
  write(list);

  if (!window.customElements) return;

  customElements.whenDefined('recently-viewed-products').then(function () {
    var RecentlyViewed = customElements.get('recently-viewed-products');
    if (!RecentlyViewed) return;

    RecentlyViewed.prototype.getQueryString = function () {
      var self = this.dataset.productId ? parseInt(this.dataset.productId, 10) : null;
      return read(KEY)
        .filter(function (id) { return id !== self; })
        .slice(0, SHOW)
        .map(function (id) { return 'id:' + id; })
        .join(' OR ');
    };

    // If the row already loaded with the theme's 4, reload it with 8.
    document.querySelectorAll('recently-viewed-products').forEach(function (row) {
      if (row.querySelector('.grid__item') && typeof row.init === 'function') row.init();
    });
  });
})();
